export default {
  home: {
    hero: {
      title: 'Caméras de sécurité et systèmes d’alarme pour particuliers et professionnels',
      subtitle: 'SSG Signaltechnik planifie, installe et entretient des systèmes modernes de vidéosurveillance et d’alarme dans toute la région Rhin-Main : de Hainburg en passant par Offenbach, Francfort et Hanau jusqu’à Darmstadt et Groß-Gerau. Adaptés individuellement à votre bien, à vos besoins et aux zones à réellement protéger.',
      ctaPrimary: 'Demander une première consultation gratuite',
      ctaSecondary: 'Lancer le planificateur de caméras',
    },
    trust: {
      '0': 'Planification individuelle',
      '1': 'Installation professionnelle',
      '2': 'Configuration de l’application',
      '3': 'Accompagnement personnel',
      '4': 'Particuliers et professionnels',
    },
    service: {
      eyebrow: 'Notre approche',
      title: 'Bien plus que monter des caméras',
      lead: 'Chaque bien est différent. C’est pourquoi nous étudions votre situation de près avant de proposer la moindre caméra. Le service complet comprend :',
      steps: {
        '0': 'Analyser les besoins et le bien',
        '1': 'Choisir le type de caméra et l’angle de vue',
        '2': 'Vérifier les éventuels angles morts',
        '3': 'Planifier le câblage, le réseau et l’enregistrement',
        '4': 'Monter et orienter dans les règles de l’art',
        '5': 'Configurer l’application et l’accès à distance',
        '6': 'Former le client de façon claire',
        '7': 'Entretenir l’installation sur demande',
      },
      more: 'Découvrir tous les services',
    },
    solutions: {
      eyebrow: 'Types de biens',
      title: 'Des solutions pour chaque bien',
      lead: 'Maison, commerce ou hall de production : nous trouvons la solution adaptée à vos besoins.',
      filter: { alle: 'Tous', privat: 'Privé', gewerbe: 'Professionnel', innen: 'Intérieur', aussen: 'Extérieur', neu: 'Nouvelle installation' },
      more: 'En savoir plus',
      viewAll: 'Voir toutes les solutions',
    },
    area: {
      eyebrow: 'Zone d’intervention',
      title: 'Caméras de sécurité et alarmes dans toute la région Rhin-Main',
      lead: 'Depuis notre site de Hainburg, nous couvrons toute l’agglomération : Francfort, Offenbach, Hanau, Darmstadt, Groß-Gerau et toutes les communes alentour. Planification, installation et entretien de votre caméra ou alarme, toujours en personne et sur place.',
      viewAll: 'Voir toutes les zones d’intervention',
    },
    tech: {
      eyebrow: 'Planification technique',
      title: 'La bonne technologie pour le bon objectif',
      lead: 'Les mégapixels ne font pas tout. Une bonne installation naît de l’interaction de nombreux facteurs.',
      points: {
        '0': { title: 'Intérieur ou extérieur', desc: 'L’humidité, les intempéries et la température déterminent le choix de la caméra.' },
        '1': { title: 'Lumière et conditions nocturnes', desc: 'Des solutions jour/nuit et basse lumière pour chaque situation d’éclairage.' },
        '2': { title: 'Vue d’ensemble ou détail', desc: 'Grand-angle pour la vue globale ou téléobjectif pour visages et plaques.' },
        '3': { title: 'Distance et hauteur de montage', desc: 'Plus c’est haut et loin, plus il faut de résolution et un meilleur objectif.' },
        '4': { title: 'Angle de vue et objectif', desc: 'Focale fixe, varifocale ou motorisée, selon l’usage.' },
        '5': { title: 'Enregistrement et stockage', desc: 'Enregistreur local avec stockage sur disque selon les besoins.' },
        '6': { title: 'Accès via l’application', desc: 'Vue en direct et lecture sur smartphone, selon le système.' },
        '7': { title: 'Notifications d’événements', desc: 'Messages push en cas de mouvement ou d’événements définissables.' },
        '8': { title: 'Extensibilité', desc: 'Les installations existantes peuvent généralement être complétées.' },
      },
    },
    process: {
      eyebrow: 'Processus',
      title: 'Comment se déroule votre projet',
      lead: 'De la première demande à l’installation terminée : transparent et personnel.',
      steps: {
        '0': { title: 'Premier entretien', desc: 'Nous discutons de vos besoins, de votre bien et des zones à surveiller.' },
        '1': { title: 'Visite et planification', desc: 'Rendez-vous sur place pour analyser lumière, angles, points de montage et câblage.' },
        '2': { title: 'Devis individuel', desc: 'Vous recevez un devis transparent avec la bonne technologie et un périmètre clair.' },
        '3': { title: 'Installation et configuration', desc: 'Montage professionnel, connexion réseau, configuration de l’enregistreur et de l’application.' },
        '4': { title: 'Formation et accompagnement', desc: 'Vous apprenez à utiliser le système. Nous restons à vos côtés, même après.' },
      },
    },
    refs: {
      eyebrow: 'Projets de référence',
      title: 'Projets réalisés',
      lead: 'Un extrait de notre portfolio : de la propriété privée aux installations professionnelles.',
      viewAll: 'Découvrir toutes les solutions',
      items: {
        '0': { label: 'Maison individuelle', desc: 'Installation complète avec 6 caméras, NVR et connexion à l’application' },
        '1': { label: 'Commerce – boutique', desc: 'Surface de vente et réserve avec 4 caméras et vision nocturne' },
        '2': { label: 'Logistique – entrepôt', desc: 'Surveillance de grandes surfaces avec grand-angle et PTZ' },
        '3': { label: 'Cabinet – accueil médical', desc: 'Surveillance intérieure discrète avec masquage de confidentialité' },
        '4': { label: 'Immobilier – immeuble d’habitation', desc: 'Entrée et extérieurs avec signalétique' },
      },
    },
    care: {
      eyebrow: 'Maintenance et accompagnement',
      title: 'SSG Care',
      lead: 'Votre technologie de caméras doit fonctionner de façon fiable dans la durée. Avec SSG Care, vous bénéficiez d’un abonnement d’accompagnement flexible : résiliable mensuellement ou avec une durée convenue.',
      list: {
        '0': 'Contrôles réguliers du système et mises à jour du firmware',
        '1': 'Assistance en cas de problème d’application ou d’accès',
        '2': 'Aide au changement de smartphone',
        '3': 'Vérification de l’enregistrement et du stockage',
        '4': 'Traitement prioritaire selon accord',
      },
      cta: 'Découvrir SSG Care',
    },
    planner: {
      eyebrow: 'Outil interactif',
      title: 'Le planificateur de caméras SSG',
      lead: 'Dessinez des pièces ou des surfaces, marquez les zones de surveillance importantes et testez les positions de caméra possibles avec des cônes de vision. Le résultat est une pré-planification non contraignante pour votre échange avec nous.',
      list: {
        '0': 'Dessiner les pièces et les murs',
        '1': 'Placer les icônes de caméra par glisser-déposer',
        '2': 'Cônes de vision rotatifs avec évaluation de la couverture',
        '3': 'Marquer les zones de surveillance et de confidentialité',
        '4': 'Envoyer le résultat en demande ou l’imprimer',
      },
      cta: 'Lancer le planificateur de caméras',
    },
    faq: {
      eyebrow: 'Questions fréquentes',
      title: 'Ce que les clients nous demandent souvent',
      viewAll: 'Voir toutes les questions',
      items: {
        '0': { question: 'Combien de caméras me faut-il ?', answer: 'Cela dépend de la taille de votre bien, des zones à surveiller et du niveau de détail souhaité. Après un premier entretien et une visite, nous élaborons une proposition individuelle.' },
        '1': { question: 'Puis-je voir les caméras sur mon smartphone ?', answer: 'Oui, avec la plupart des systèmes modernes, l’accès via une application est possible. Nous configurons la connexion de l’application directement lors de l’installation.' },
        '2': { question: 'Les caméras fonctionnent-elles dans l’obscurité ?', answer: 'Oui, pour les extérieurs et les intérieurs peu éclairés, il existe des caméras jour/nuit et basse lumière avec vision nocturne infrarouge ou en couleur.' },
        '3': { question: 'Combien coûte une installation de caméras ?', answer: 'Le coût dépend du nombre de caméras, du bien, du câblage et des fonctions souhaitées. Nous élaborons volontiers un devis individuel et sans engagement.' },
      },
    },
    cta: {
      title: 'Découvrons ensemble quelle solution convient à votre bien.',
      lead: 'Appelez-nous, écrivez-nous ou lancez directement le planificateur de caméras. Nous vous répondrons rapidement.',
      primary: 'Demander une première consultation gratuite',
      secondary: 'Lancer le planificateur de caméras',
    },
  },
  company: {
    solutions: {
      home: { title: 'Maison et terrain', description: 'De la porte d’entrée au garage : une surveillance discrète pour votre domicile.' },
      retail: { title: 'Commerce et restauration', description: 'Caisse, entrée et réserve : sécurisés de façon professionnelle.' },
      office: { title: 'Bureau et cabinet', description: 'Accueil, couloirs et zones sensibles : planifiés dans le respect de la vie privée.' },
      warehouse: { title: 'Entrepôt et logistique', description: 'Surveillance de grandes surfaces avec grand-angle et vision nocturne.' },
      workshop: { title: 'Atelier et artisanat', description: 'Caméras robustes pour les environnements exigeants : ateliers et extérieurs.' },
      apartment: { title: 'Immeubles et biens immobiliers', description: 'Entrées, cages d’escalier et extérieurs, pour locataires et propriétaires.' },
    },
  },
};